export default "__VITE_ASSET__4Q1kEDzS__"